







































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { AppStore } from '@interface/store/App';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class UserDropdown extends Vue {};

